import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "max-w-7xl mx-auto py-10 px-4 sm:px-6 lg:px-8"
}
const _hoisted_2 = { class: "mb-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-b border-gray-100 pb-5" }
const _hoisted_3 = {
  key: 0,
  class: "mt-1.5 text-sm text-gray-500 font-regular"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-1.5 text-sm text-gray-500 font-regular"
}
const _hoisted_5 = { class: "grid grid-cols-1 gap-8 lg:grid-cols-4" }
const _hoisted_6 = { class: "lg:col-span-1 flex flex-col gap-6" }
const _hoisted_7 = { class: "bg-white rounded-2xl shadow-custom-symetric overflow-hidden border border-gray-100 p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-lg" }
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "h-24 w-24 rounded-full object-cover ring-4 ring-theme-active/20 group-hover:ring-theme-active/50 transition-all duration-300",
  src: "/assets/avatars/default.jpg",
  alt: ""
}
const _hoisted_11 = { class: "absolute inset-0 bg-black/40 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" }
const _hoisted_12 = { class: "mt-4 font-bold text-lg text-gray-900" }
const _hoisted_13 = { class: "text-sm text-gray-500 font-regular truncate max-w-full" }
const _hoisted_14 = {
  key: 0,
  class: "mt-3 inline-flex items-center rounded-full bg-theme-active/10 px-3 py-1 text-xs font-semibold text-theme-active uppercase tracking-wide"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-3 inline-flex items-center rounded-full bg-blue-100 px-3 py-1 text-xs font-semibold text-blue-800 uppercase tracking-wide"
}
const _hoisted_16 = {
  key: 2,
  class: "mt-3 inline-flex items-center rounded-full bg-purple-100 px-3 py-1 text-xs font-semibold text-purple-800 uppercase tracking-wide"
}
const _hoisted_17 = { class: "bg-white rounded-2xl shadow-custom-symetric overflow-hidden border border-gray-100 p-4" }
const _hoisted_18 = { class: "flex flex-row lg:flex-col gap-1 overflow-x-auto lg:overflow-x-visible pb-2 lg:pb-0 scrollbar-none" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "lg:col-span-3 flex flex-col gap-6" }
const _hoisted_24 = {
  key: 0,
  class: "p-5 bg-amber-50 border border-amber-200/60 rounded-2xl flex gap-4 items-start shadow-sm transition-all duration-300"
}
const _hoisted_25 = { class: "h-10 w-10 rounded-xl bg-amber-100/80 text-amber-800 flex items-center justify-center shrink-0" }
const _hoisted_26 = {
  key: 1,
  class: "bg-white rounded-2xl shadow-custom-symetric border border-gray-100 overflow-hidden transition-all duration-300"
}
const _hoisted_27 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_28 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_29 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = ["readonly", "disabled"]
const _hoisted_32 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_33 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_38 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_39 = {
  key: 0,
  class: "border-t border-gray-100 pt-6 mt-4"
}
const _hoisted_40 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_41 = { class: "mt-2" }
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = { class: "mt-2" }
const _hoisted_44 = { class: "mt-2" }
const _hoisted_45 = { class: "mt-2" }
const _hoisted_46 = { class: "mt-2" }
const _hoisted_47 = { class: "mt-2" }
const _hoisted_48 = { class: "flex items-center justify-between border-t border-gray-100 pt-6 mt-4" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = {
  key: 2,
  class: "bg-white rounded-2xl shadow-custom-symetric border border-gray-100 overflow-hidden transition-all duration-300"
}
const _hoisted_51 = { class: "p-6" }
const _hoisted_52 = {
  key: 3,
  class: "bg-white rounded-2xl shadow-custom-symetric border border-gray-100 overflow-hidden transition-all duration-300"
}
const _hoisted_53 = { class: "flex flex-col gap-6" }
const _hoisted_54 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_55 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_56 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }
const _hoisted_57 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_58 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_59 = { class: "mt-2 relative rounded-md shadow-sm" }
const _hoisted_60 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_61 = {
  key: 4,
  class: "flex flex-col gap-6"
}
const _hoisted_62 = {
  key: 0,
  class: "bg-gradient-to-r from-emerald-800 to-teal-950 rounded-3xl p-6 text-white shadow-lg border border-teal-700/30 flex flex-col md:flex-row items-center justify-between gap-6 relative overflow-hidden"
}
const _hoisted_63 = { class: "flex-grow w-full md:w-auto" }
const _hoisted_64 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_65 = { class: "text-sm text-teal-100 font-semibold leading-relaxed max-w-2xl" }
const _hoisted_66 = { class: "text-white font-extrabold text-lg px-1.5 py-0.5 rounded bg-white/10" }
const _hoisted_67 = { class: "text-emerald-300 font-bold" }
const _hoisted_68 = { class: "font-extrabold" }
const _hoisted_69 = { class: "text-teal-300 font-bold" }
const _hoisted_70 = { class: "mt-5 w-full bg-teal-950/50 rounded-full h-3 border border-teal-800/30" }
const _hoisted_71 = { class: "flex justify-between items-center mt-2 text-xs font-semibold text-teal-300" }
const _hoisted_72 = { class: "flex-shrink-0 w-full md:w-auto text-right" }
const _hoisted_73 = {
  key: 0,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-emerald-900/50 border border-emerald-700/50 text-emerald-300/80 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_74 = {
  key: 2,
  disabled: "",
  class: "w-full md:w-auto px-6 py-3.5 bg-white/20 text-white/50 border border-white/10 font-extrabold text-sm rounded-xl cursor-not-allowed uppercase tracking-wider"
}
const _hoisted_75 = { class: "bg-white rounded-2xl shadow-custom-symetric border border-gray-100 overflow-hidden" }
const _hoisted_76 = { class: "overflow-x-auto" }
const _hoisted_77 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_78 = { class: "divide-y divide-gray-200 bg-white" }
const _hoisted_79 = { class: "whitespace-nowrap py-4 pl-6 pr-3 text-sm text-gray-900" }
const _hoisted_80 = {
  key: 0,
  class: "ml-2 px-1.5 py-0.5 rounded text-[10px] font-bold bg-rose-50 text-rose-700 border border-rose-200 uppercase"
}
const _hoisted_81 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-900 font-semibold" }
const _hoisted_82 = { class: "whitespace-nowrap px-3 py-4 text-sm text-gray-500" }
const _hoisted_83 = { key: 0 }
const _hoisted_84 = {
  key: 5,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
}
const _hoisted_85 = { class: "bg-white rounded-3xl shadow-2xl border border-gray-100 max-w-md w-full p-8 flex flex-col relative overflow-hidden" }
const _hoisted_86 = { class: "flex flex-col gap-4" }
const _hoisted_87 = { class: "flex flex-col gap-1.5" }
const _hoisted_88 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold"
}
const _hoisted_89 = { class: "flex flex-col gap-1.5" }
const _hoisted_90 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold"
}
const _hoisted_91 = { class: "flex flex-col gap-1.5" }
const _hoisted_92 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold"
}
const _hoisted_93 = { class: "flex flex-col gap-1.5" }
const _hoisted_94 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold"
}
const _hoisted_95 = { class: "flex flex-col gap-1.5 mt-2" }
const _hoisted_96 = { class: "relative rounded-xl border border-gray-200 flex items-center bg-gray-50 focus-within:bg-white focus-within:border-theme-active transition-all duration-200" }
const _hoisted_97 = ["max"]
const _hoisted_98 = { class: "pr-4 text-xs font-bold text-emerald-600 whitespace-nowrap" }
const _hoisted_99 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold mt-1 text-left"
}
const _hoisted_100 = { class: "text-[10px] text-gray-400 mt-1 font-medium text-left" }
const _hoisted_101 = {
  key: 0,
  class: "text-xs text-rose-600 font-semibold mt-2 text-left"
}
const _hoisted_102 = { class: "flex items-center justify-end gap-3 mt-6" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
}
const _hoisted_105 = { class: "bg-white rounded-3xl shadow-2xl border border-gray-100 max-w-md w-full p-8 flex flex-col items-center text-center relative overflow-hidden transition-all duration-300 transform scale-100" }
const _hoisted_106 = { class: "h-16 w-16 bg-red-50 rounded-full flex items-center justify-center text-red-500 mb-6 ring-8 ring-red-50" }

import { ref, onMounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import Agent from '@/composables/admin/agent'
import Corporate from '@/composables/admin/corporate'
import User from '@/composables/User'
import BookingsTable from '@/components/account/BookingsTable.vue'
import { handleApiError, isImageFile, isLoggedIn, resetErrors, truncateText, updateAuthUser, logout } from '@/utils/common'
import { NotificationType } from '@/types'
import Notification from '@/widgets/Notification.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  props: ['userType'],
  setup(__props) {

const props = __props
const authUser = isLoggedIn()
const router = useRouter()
const currentTab = ref<string>('personal')
const showPasswordChangeAlert = ref<boolean>(false)

const { agentProfile, agentProfileSave } = Agent()
const { corporateProfile, corporateProfileSave } = Corporate()
const { userProfile, userProfileSave, customerLoyaltyLogs, customerRequestRedeemLoyalty } = User()

const notif = ref<NotificationType>({ show: false, type: 'success', message: '', messageDetails: ''})
const isLoading = ref<boolean>(true)
const fileInput = ref<HTMLInputElement | null>(null)

const userAccount = ref<any>({
   personal: {
      fullName: '',
      email: '',
      photo: null,
      photoName: '',
      commission: 0,
      phone: '',
      company: '',
      country: '',
      crNumber: '',
      vatNumber: '',
      bankName: '',
      bankAccountName: '',
      bankAccountNumber: '',
      bankIban: '',
      bankSwift: '',
      isParent: false
   },
   password: {
      current: '',
      new: '',
      confirmNew: ''
   }
})

const errors = ref<any>({
   personal: {
      fullName: null,
      commission: null,
      phone: null,
      company: null
   },
   password: {
      current: null,
      new: null,
      confirmNew: null
   }
})

onMounted(async () => {
   if (authUser && authUser.user.type == 'agent') {
      await fetchAgentProfile()
      if (authUser.user.has_setup_password === 0) {
         currentTab.value = 'password'
         showPasswordChangeAlert.value = true
      }
   } else if (authUser && authUser.user.type == 'corporate'){
      await fetchCorporateProfile()
   } else if (authUser && authUser.user.type == 'web'){
      await fetchUserProfile()
      document.title = 'My Profile - Vehitra World'
      if (authUser.user.require_password_change) {
         currentTab.value = 'password'
         showPasswordChangeAlert.value = true
      }
      await fetchCustomerLoyalty()
   }
})

const loyaltyLogsList = ref<any[]>([])
const customerLoyaltySummary = ref<any>(null)
const showLoyaltyRedeemModal = ref<boolean>(false)
const isLoyaltyBusy = ref<boolean>(false)
const loyaltyRedeemForm = ref<any>({
   bankName: { value: '', error: false, errorMessage: '' },
   accountName: { value: '', error: false, errorMessage: '' },
   accountNumber: { value: '', error: false, errorMessage: '' },
   countryName: { value: '', error: false, errorMessage: '' },
   error: ''
})

const fetchCustomerLoyalty = async () => {
   const response = await customerLoyaltyLogs()
   if (response.status === 200) {
      loyaltyLogsList.value = response.data.logs || []
      customerLoyaltySummary.value = response.data.loyalty_summary || null
   }
}

watch(currentTab, async (newTab) => {
   if (newTab === 'loyalty') {
      await fetchCustomerLoyalty()
   }
})

const b2cPointsToWithdraw = ref<number | null>(null)
const b2cPointsError = ref<string>('')

const openB2CLoyaltyModal = () => {
   b2cPointsToWithdraw.value = customerLoyaltySummary.value ? Math.floor(Number(customerLoyaltySummary.value.points_earned)) : 0
   b2cPointsError.value = ''
   showLoyaltyRedeemModal.value = true
}

const handleLoyaltySubmit = async () => {
   let isValid = true
   loyaltyRedeemForm.value.bankName.error = false
   loyaltyRedeemForm.value.accountName.error = false
   loyaltyRedeemForm.value.accountNumber.error = false
   loyaltyRedeemForm.value.countryName.error = false
   loyaltyRedeemForm.value.error = ''
   b2cPointsError.value = ''

   if (loyaltyRedeemForm.value.bankName.value === '') {
      loyaltyRedeemForm.value.bankName.error = true
      isValid = false
   }
   if (loyaltyRedeemForm.value.accountName.value === '') {
      loyaltyRedeemForm.value.accountName.error = true
      isValid = false
   }
   if (loyaltyRedeemForm.value.accountNumber.value === '') {
      loyaltyRedeemForm.value.accountNumber.error = true
      isValid = false
   }
   if (loyaltyRedeemForm.value.countryName.value === '') {
      loyaltyRedeemForm.value.countryName.error = true
      isValid = false
   }
   if (!b2cPointsToWithdraw.value || b2cPointsToWithdraw.value <= 0) {
      b2cPointsError.value = 'Please enter a valid points amount'
      isValid = false
   } else if (customerLoyaltySummary.value && b2cPointsToWithdraw.value > Number(customerLoyaltySummary.value.points_earned)) {
      b2cPointsError.value = 'Cannot exceed your accumulated points'
      isValid = false
   }

   if (!isValid) return

   isLoyaltyBusy.value = true
   const response = await customerRequestRedeemLoyalty(
      loyaltyRedeemForm.value.bankName.value,
      loyaltyRedeemForm.value.accountName.value,
      loyaltyRedeemForm.value.accountNumber.value,
      loyaltyRedeemForm.value.countryName.value,
      b2cPointsToWithdraw.value || 0
   )
   isLoyaltyBusy.value = false

   if (response.status === 200) {
      showLoyaltyRedeemModal.value = false
      notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Withdrawal request submitted successfully' }
      setTimeout(() => { notifClosed() }, 5000)
      // reset form
      loyaltyRedeemForm.value.bankName.value = ''
      loyaltyRedeemForm.value.accountName.value = ''
      loyaltyRedeemForm.value.accountNumber.value = ''
      loyaltyRedeemForm.value.countryName.value = ''
      
      await fetchCustomerLoyalty()
   } else {
      loyaltyRedeemForm.value.error = handleApiError(response)
   }
}

const handleLogout = () => {
   logout(router)
}

const fetchAgentProfile = async () => {
   isLoading.value = true
   const response = await agentProfile()
   isLoading.value = false

   if (response.status == 200) {
      userAccount.value.personal = {
         fullName: response.data.data.name,
         email: response.data.data.email,
         photoName: response.data.data.photo,
         commission: response.data.data.commission,
         phone: response.data.data.phone,
         company: response.data.data.company,
         crNumber: response.data.data.cr_number || '',
         vatNumber: response.data.data.vat_number || '',
         bankName: response.data.data.bank_name || '',
         bankAccountName: response.data.data.bank_account_name || '',
         bankAccountNumber: response.data.data.bank_account_number || '',
         bankIban: response.data.data.bank_iban || '',
         bankSwift: response.data.data.bank_swift || '',
         country: response.data.data.country || '',
         isParent: response.data.data.is_parent
      }
   } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
      setTimeout(() => { notifClosed() }, 4000)
   }
}

const fetchCorporateProfile = async () => {
   isLoading.value = true
   const response = await corporateProfile()
   isLoading.value = false

   if (response.status == 200) {
      userAccount.value.personal = {
         fullName: response.data.data.name,
         email: response.data.data.email,
         photoName: response.data.data.photo,
         commission: response.data.data.commission,
         phone: response.data.data.phone,
         company: response.data.data.company
      }
   } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
      setTimeout(() => { notifClosed() }, 4000)
   }
}

const fetchUserProfile = async () => {
   isLoading.value = true
   const response = await userProfile()
   isLoading.value = false

   if (response.status == 200) {
      userAccount.value.personal = {
         fullName: response.data.data.name,
         email: response.data.data.email,
         photoName: response.data.data.photo,
         commission: response.data.data.commission,
         phone: response.data.data.phone,
         company: response.data.data.company,
         country: response.data.data.country || ''
      }
   } else {
      const error = handleApiError(response)
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
      setTimeout(() => { notifClosed() }, 4000)
   }
}

const handlePersonalSubmit = async () => {
   if (!isLoading.value) {
      resetErrors(errors.value)
      const isValid = validateForm('personal')
   
      if (isValid) {
         isLoading.value = true
         let response : any

         if (authUser && authUser.user.type == 'agent') {
            response = await agentProfileSave(userAccount.value.personal, 'personal')
         } else if (authUser && authUser.user.type == 'corporate') {
            response = await corporateProfileSave(userAccount.value.personal, 'personal')
         } else if (authUser && authUser.user.type == 'web') {
            response = await userProfileSave(userAccount.value.personal, 'personal')
         }

         isLoading.value = false
         if (response.status == 200) {
            notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Profile updated'}
            setTimeout(() => { notifClosed() }, 4000)
            
            if (authUser && authUser.user.type == 'agent') {
               await fetchAgentProfile()
            } else if (authUser && authUser.user.type == 'corporate') {
               await fetchCorporateProfile()
            } else if (authUser && authUser.user.type == 'web') {
               await fetchUserProfile()
            }

            updateAuthUser(response.data.user)
         } else {
            const error = handleApiError(response)
            notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
            setTimeout(() => { notifClosed() }, 4000)
         } 
      }
   }
}

const handlePasswordSubmit = async () => {
   if (!isLoading.value) {
      resetErrors(errors.value)
      const isValid = validateForm('password')
   
      if (isValid) {
         isLoading.value = true
         let response : any

         if (authUser && authUser.user.type == 'agent') {
            response = await agentProfileSave(userAccount.value.password, 'password')
         } else if (authUser && authUser.user.type == 'corporate') {
            response = await corporateProfileSave(userAccount.value.password, 'password')
         } else if (authUser && authUser.user.type == 'web') {
            response = await userProfileSave(userAccount.value.password, 'password')
         }

         isLoading.value = false
         if (response.status == 200) {
            userAccount.value.password = {
               current: '',
               new: '',
               confirmNew: ''
            }
            notif.value = { show: true, type: 'success', message: 'Success', messageDetails: 'Password updated'}
            setTimeout(() => { notifClosed() }, 4000)
            showPasswordChangeAlert.value = false
         } else {
            const error = handleApiError(response)
            notif.value = { show: true, type: 'error', message: 'Error', messageDetails: error}
            setTimeout(() => { notifClosed() }, 4000)
         }
      }
   }
}

const notifClosed = () : void => {
   notif.value.show = false
}

const validateForm = (type: string) : boolean => {
   let response = true

   if (type == 'personal') {
      if (authUser && authUser.user.type === 'web') {
         if (userAccount.value.personal.fullName == '') {
            errors.value.personal.fullName = true
            response = false
         }
         if (userAccount.value.personal.phone == '') {
            errors.value.personal.phone = true
            response = false
         }
      }
      if (authUser && authUser.user.type !== 'web') {
         if (userAccount.value.personal.commission < 0 || userAccount.value.personal.commission > 50) {
            errors.value.personal.commission = 'Invalid value. It must be between 1 and 50'
            response = false
         }
      }
   } else if (type == 'password'){
      if (userAccount.value.password.current == '') {
         errors.value.password.current = true
         response = false
      }

      if (userAccount.value.password.new == '') {
         errors.value.password.new = 'This field is required'
         response = false
      } else if (userAccount.value.password.new.length < 6) {
         errors.value.password.new = 'Password must be at least 6 characters long'
         response = false
      }

      if (userAccount.value.password.confirmNew == '') {
         errors.value.password.confirmNew = 'This field is required'
         response = false
      } else if (userAccount.value.password.new != '' && userAccount.value.password.new != userAccount.value.password.confirmNew){
         errors.value.password.confirmNew = 'Confirm password must be the same as new password'
         response = false
      }
   }

   return response
}

const handleChooseAvatar = () => {
   fileInput.value?.click()
}

const uploadMedia = (e: Event) => {
   userAccount.value.personal.photo = null
   userAccount.value.personal.photoName = ''
   const inputElement = e.target as HTMLInputElement

   if (!inputElement.files || inputElement.files.length === 0) {
      return;
   }

   const file = inputElement.files[0]
   const reader = new FileReader()

   if (!isImageFile(file)) {
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'File must be an image of type JPG or PNG'}
   } else if (file.size > 3145728) {
      notif.value = { show: true, type: 'error', message: 'Error', messageDetails: 'Image must be 3MB or less'}
   }

   userAccount.value.personal.photoName = file.name

   reader.onloadend = () => {
      userAccount.value.personal.photo = reader.result as string
   }

   reader.readAsDataURL(file)
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(authUser))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _cache[29] || (_cache[29] = _createElementVNode("h1", { class: "text-3xl font-extrabold tracking-tight text-gray-900 font-bold" }, "My Profile", -1)),
              (_unref(authUser).user.type === 'web')
                ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Manage your profile details, update your security parameters, and review your transfer reservations."))
                : (_openBlock(), _createElementBlock("p", _hoisted_4, "Manage your partner profile details, update your company info, and review your security parameters."))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  class: "relative group cursor-pointer",
                  onClick: handleChooseAvatar
                }, [
                  (userAccount.value.personal.photo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "h-24 w-24 rounded-full object-cover ring-4 ring-theme-active/20 group-hover:ring-theme-active/50 transition-all duration-300",
                        src: userAccount.value.personal.photo,
                        alt: ""
                      }, null, 8, _hoisted_8))
                    : (userAccount.value.personal.photoName != '')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "h-24 w-24 rounded-full object-cover ring-4 ring-theme-active/20 group-hover:ring-theme-active/50 transition-all duration-300",
                          src: userAccount.value.personal.photoName,
                          alt: ""
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createElementBlock("img", _hoisted_10)),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-camera",
                      class: "text-white text-lg"
                    })
                  ])
                ]),
                _createElementVNode("h3", _hoisted_12, _toDisplayString(userAccount.value.personal.fullName || 'User'), 1),
                _createElementVNode("p", _hoisted_13, _toDisplayString(userAccount.value.personal.email), 1),
                (_unref(authUser).user.type === 'web')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " Customer "))
                  : (_unref(authUser).user.type === 'agent')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(authUser).user.sub_type === 'sub_agent' ? 'Sub-Agent Partner' : 'Agent Partner'), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, " Corporate Partner "))
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("nav", _hoisted_18, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (!showPasswordChangeAlert.value && (currentTab.value = 'personal'))),
                    disabled: showPasswordChangeAlert.value,
                    class: _normalizeClass([currentTab.value === 'personal' ? 'bg-theme-active text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', showPasswordChangeAlert.value ? 'opacity-40 cursor-not-allowed' : '', 'flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 whitespace-nowrap w-full text-left'])
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-user",
                      class: "w-5"
                    }),
                    _cache[30] || (_cache[30] = _createTextVNode(" Account Details "))
                  ], 10, _hoisted_19),
                  (_unref(authUser).user.type === 'web')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (!showPasswordChangeAlert.value && (currentTab.value = 'bookings'))),
                        disabled: showPasswordChangeAlert.value,
                        class: _normalizeClass([currentTab.value === 'bookings' ? 'bg-theme-active text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', showPasswordChangeAlert.value ? 'opacity-40 cursor-not-allowed' : '', 'flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 whitespace-nowrap w-full text-left'])
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-list",
                          class: "w-5"
                        }),
                        _cache[31] || (_cache[31] = _createTextVNode(" My Bookings "))
                      ], 10, _hoisted_20))
                    : _createCommentVNode("", true),
                  (_unref(authUser).user.type === 'web')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (!showPasswordChangeAlert.value && (currentTab.value = 'loyalty'))),
                        disabled: showPasswordChangeAlert.value,
                        class: _normalizeClass([currentTab.value === 'loyalty' ? 'bg-theme-active text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', showPasswordChangeAlert.value ? 'opacity-40 cursor-not-allowed' : '', 'flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 whitespace-nowrap w-full text-left'])
                      }, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "fa-solid fa-gift",
                          class: "w-5"
                        }),
                        _cache[32] || (_cache[32] = _createTextVNode(" Loyalty Rewards "))
                      ], 10, _hoisted_21))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (currentTab.value = 'password')),
                    class: _normalizeClass([currentTab.value === 'password' ? 'bg-theme-active text-white shadow-sm' : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900', 'flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl transition-all duration-300 whitespace-nowrap w-full text-left'])
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-lock",
                      class: "w-5"
                    }),
                    _cache[33] || (_cache[33] = _createTextVNode(" Change Password "))
                  ], 2),
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "h-px bg-gray-100 my-2 hidden lg:block" }, null, -1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (!showPasswordChangeAlert.value && handleLogout())),
                    disabled: showPasswordChangeAlert.value,
                    class: _normalizeClass([[showPasswordChangeAlert.value ? 'opacity-40 cursor-not-allowed' : ''], "flex items-center gap-3 px-4 py-3 text-sm font-semibold rounded-xl text-red-600 hover:bg-red-50 transition-all duration-300 whitespace-nowrap w-full text-left"])
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-right-from-bracket",
                      class: "w-5"
                    }),
                    _cache[34] || (_cache[34] = _createTextVNode(" Log Out "))
                  ], 10, _hoisted_22)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              (_unref(authUser).user.has_setup_password === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createVNode(_component_font_awesome_icon, {
                        icon: "fa-solid fa-circle-info",
                        class: "text-lg"
                      })
                    ]),
                    _cache[36] || (_cache[36] = _createElementVNode("div", null, [
                      _createElementVNode("h4", { class: "font-bold text-amber-900 text-sm uppercase tracking-wider" }, "Account Setup Required"),
                      _createElementVNode("p", { class: "text-xs text-amber-700/90 mt-1 leading-relaxed" }, " Please set your real email address and update your password to complete your account setup. This will unlock B2B dashboard features. ")
                    ], -1))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("input", {
                class: "hidden",
                ref_key: "fileInput",
                ref: fileInput,
                type: "file",
                onChange: uploadMedia,
                accept: "image/*"
              }, null, 544),
              (currentTab.value === 'personal')
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "px-6 py-5 border-b border-gray-100" }, [
                      _createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "Account Details"),
                      _createElementVNode("p", { class: "mt-1 text-sm text-gray-500 font-regular" }, "Review and update your personal contact details below.")
                    ], -1)),
                    _createElementVNode("form", {
                      class: "p-6 flex flex-col gap-6",
                      onSubmit: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", null, [
                          _cache[37] || (_cache[37] = _createElementVNode("label", {
                            for: "full-name",
                            class: "block text-sm font-bold text-gray-700"
                          }, "Full name *", -1)),
                          _createElementVNode("div", _hoisted_28, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((userAccount.value.personal.fullName) = $event)),
                              type: "text",
                              id: "full-name",
                              class: _normalizeClass([errors.value.personal.fullName ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                            }, null, 2), [
                              [_vModelText, userAccount.value.personal.fullName]
                            ])
                          ]),
                          (errors.value.personal.fullName)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_29, "This field is required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", {
                            for: "email",
                            class: "block text-sm font-bold text-gray-700"
                          }, "Email Address", -1)),
                          _createElementVNode("div", _hoisted_30, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((userAccount.value.personal.email) = $event)),
                              type: "text",
                              readonly: _unref(authUser).user.has_setup_password !== 0,
                              disabled: _unref(authUser).user.has_setup_password !== 0,
                              id: "email",
                              class: _normalizeClass([_unref(authUser).user.has_setup_password !== 0 ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : 'bg-white text-gray-900 focus:ring-theme-active', "block w-full rounded-xl border border-gray-200 py-3 px-4 sm:text-sm font-regular outline-none transition-all duration-300"])
                            }, null, 10, _hoisted_31), [
                              [_vModelText, userAccount.value.personal.email]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[39] || (_cache[39] = _createElementVNode("label", {
                            for: "phone",
                            class: "block text-sm font-bold text-gray-700"
                          }, "Phone Number *", -1)),
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((userAccount.value.personal.phone) = $event)),
                              type: "text",
                              id: "phone",
                              class: _normalizeClass([errors.value.personal.phone ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                            }, null, 2), [
                              [_vModelText, userAccount.value.personal.phone]
                            ])
                          ]),
                          (errors.value.personal.phone)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_33, "This field is required"))
                            : _createCommentVNode("", true)
                        ]),
                        (_unref(authUser).user.type === 'web' || _unref(authUser).user.type === 'agent')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _cache[40] || (_cache[40] = _createElementVNode("label", {
                                for: "country",
                                class: "block text-sm font-bold text-gray-700"
                              }, "Country", -1)),
                              _createElementVNode("div", _hoisted_35, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((userAccount.value.personal.country) = $event)),
                                  type: "text",
                                  id: "country",
                                  class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                  placeholder: "Enter your country"
                                }, null, 512), [
                                  [_vModelText, userAccount.value.personal.country]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(authUser).user.type !== 'web')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _cache[41] || (_cache[41] = _createElementVNode("label", {
                                for: "company-name",
                                class: "block text-sm font-bold text-gray-700"
                              }, "Company Name *", -1)),
                              _createElementVNode("div", _hoisted_37, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userAccount.value.personal.company) = $event)),
                                  type: "text",
                                  id: "company-name",
                                  class: _normalizeClass([errors.value.personal.company ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                                }, null, 2), [
                                  [_vModelText, userAccount.value.personal.company]
                                ])
                              ]),
                              (errors.value.personal.company)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_38, "This field is required"))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_unref(authUser).user.type === 'agent' && userAccount.value.personal.isParent)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _cache[49] || (_cache[49] = _createElementVNode("h3", { class: "text-lg font-bold text-gray-900 mb-4" }, "Agency Documents & Bank Details", -1)),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", null, [
                                _cache[42] || (_cache[42] = _createElementVNode("label", {
                                  for: "cr-number",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "CR Number", -1)),
                                _createElementVNode("div", _hoisted_41, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((userAccount.value.personal.crNumber) = $event)),
                                    type: "text",
                                    id: "cr-number",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter Commercial Registration Number"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.crNumber]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[43] || (_cache[43] = _createElementVNode("label", {
                                  for: "vat-number",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "VAT Number", -1)),
                                _createElementVNode("div", _hoisted_42, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userAccount.value.personal.vatNumber) = $event)),
                                    type: "text",
                                    id: "vat-number",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter VAT Registration Number"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.vatNumber]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[44] || (_cache[44] = _createElementVNode("label", {
                                  for: "bank-name",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "Bank Name", -1)),
                                _createElementVNode("div", _hoisted_43, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((userAccount.value.personal.bankName) = $event)),
                                    type: "text",
                                    id: "bank-name",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter Bank Name"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.bankName]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[45] || (_cache[45] = _createElementVNode("label", {
                                  for: "bank-account-name",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "Bank Account Name", -1)),
                                _createElementVNode("div", _hoisted_44, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((userAccount.value.personal.bankAccountName) = $event)),
                                    type: "text",
                                    id: "bank-account-name",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter Account Name"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.bankAccountName]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[46] || (_cache[46] = _createElementVNode("label", {
                                  for: "bank-account-number",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "Bank Account Number", -1)),
                                _createElementVNode("div", _hoisted_45, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((userAccount.value.personal.bankAccountNumber) = $event)),
                                    type: "text",
                                    id: "bank-account-number",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter Account Number"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.bankAccountNumber]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[47] || (_cache[47] = _createElementVNode("label", {
                                  for: "bank-iban",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "IBAN", -1)),
                                _createElementVNode("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((userAccount.value.personal.bankIban) = $event)),
                                    type: "text",
                                    id: "bank-iban",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter IBAN Number"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.bankIban]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _cache[48] || (_cache[48] = _createElementVNode("label", {
                                  for: "bank-swift",
                                  class: "block text-sm font-bold text-gray-700"
                                }, "SWIFT / BIC Code", -1)),
                                _createElementVNode("div", _hoisted_47, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((userAccount.value.personal.bankSwift) = $event)),
                                    type: "text",
                                    id: "bank-swift",
                                    class: "block w-full rounded-xl border border-gray-200 py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm",
                                    placeholder: "Enter SWIFT Code"
                                  }, null, 512), [
                                    [_vModelText, userAccount.value.personal.bankSwift]
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, [
                        _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-xs text-gray-500 font-regular" }, "* Required field", -1)),
                        _createElementVNode("button", {
                          onClick: handlePersonalSubmit,
                          type: "button",
                          disabled: isLoading.value,
                          class: "rounded-xl bg-theme-active hover:bg-theme-active/90 text-white font-semibold text-sm px-6 py-3 shadow-md transition-all duration-300 flex items-center justify-center gap-2"
                        }, [
                          (isLoading.value)
                            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                key: 0,
                                icon: "fa-solid fa-spinner",
                                class: "animate-spin"
                              }))
                            : _createCommentVNode("", true),
                          _cache[50] || (_cache[50] = _createTextVNode(" Save Changes "))
                        ], 8, _hoisted_49)
                      ])
                    ], 32)
                  ]))
                : _createCommentVNode("", true),
              (currentTab.value === 'bookings' && _unref(authUser).user.type === 'web')
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _cache[53] || (_cache[53] = _createElementVNode("div", { class: "px-6 py-5 border-b border-gray-100" }, [
                      _createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "My Bookings"),
                      _createElementVNode("p", { class: "mt-1 text-sm text-gray-500 font-regular" }, "View and manage all your transfer reservation requests and vouchers.")
                    ], -1)),
                    _createElementVNode("div", _hoisted_51, [
                      _createVNode(BookingsTable, { subUserId: "" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (currentTab.value === 'password')
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _cache[57] || (_cache[57] = _createElementVNode("div", { class: "px-6 py-5 border-b border-gray-100" }, [
                      _createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "Change Password"),
                      _createElementVNode("p", { class: "mt-1 text-sm text-gray-500 font-regular" }, "Ensure your account stays secure by changing your password regularly.")
                    ], -1)),
                    _createElementVNode("form", {
                      class: "p-6 flex flex-col gap-6",
                      onSubmit: _cache[21] || (_cache[21] = _withModifiers(() => {}, ["prevent"]))
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("div", null, [
                          _cache[54] || (_cache[54] = _createElementVNode("label", {
                            for: "current-password",
                            class: "block text-sm font-bold text-gray-700"
                          }, "Current Password", -1)),
                          _createElementVNode("div", _hoisted_54, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((userAccount.value.password.current) = $event)),
                              type: "password",
                              id: "current-password",
                              class: _normalizeClass([errors.value.password.current ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                            }, null, 2), [
                              [_vModelText, userAccount.value.password.current]
                            ])
                          ]),
                          (errors.value.password.current)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_55, "This field is required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", null, [
                            _cache[55] || (_cache[55] = _createElementVNode("label", {
                              for: "new-password",
                              class: "block text-sm font-bold text-gray-700"
                            }, "New Password", -1)),
                            _createElementVNode("div", _hoisted_57, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((userAccount.value.password.new) = $event)),
                                type: "password",
                                id: "new-password",
                                class: _normalizeClass([errors.value.password.new ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                              }, null, 2), [
                                [_vModelText, userAccount.value.password.new]
                              ])
                            ]),
                            (errors.value.password.new)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_58, _toDisplayString(errors.value.password.new), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            _cache[56] || (_cache[56] = _createElementVNode("label", {
                              for: "password-confirmation",
                              class: "block text-sm font-bold text-gray-700"
                            }, "Confirm Password", -1)),
                            _createElementVNode("div", _hoisted_59, [
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((userAccount.value.password.confirmNew) = $event)),
                                type: "password",
                                id: "password-confirmation",
                                class: _normalizeClass([errors.value.password.confirmNew ? 'ring-red-500 border-red-500' : 'ring-gray-200 border-gray-200', "block w-full rounded-xl border py-3 px-4 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-theme-active focus:border-transparent outline-none transition-all duration-300 sm:text-sm"])
                              }, null, 2), [
                                [_vModelText, userAccount.value.password.confirmNew]
                              ])
                            ]),
                            (errors.value.password.confirmNew)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(errors.value.password.confirmNew), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ], 32)
                  ]))
                : _createCommentVNode("", true),
              (currentTab.value === 'loyalty')
                ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "bg-white rounded-2xl p-6 border border-gray-100 shadow-custom-symetric" }, [
                      _createElementVNode("h2", { class: "text-xl font-bold text-gray-900" }, "Loyalty Program"),
                      _createElementVNode("p", { class: "text-sm text-gray-500 font-regular mt-1" }, "Track your booking rewards points and request cashback payouts.")
                    ], -1)),
                    (customerLoyaltySummary.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _cache[66] || (_cache[66] = _createElementVNode("div", { class: "absolute -right-16 -top-16 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
                          _cache[67] || (_cache[67] = _createElementVNode("div", { class: "absolute -left-16 -bottom-16 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none" }, null, -1)),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: "fa-solid fa-gift",
                                class: "text-xl text-emerald-400"
                              }),
                              _cache[58] || (_cache[58] = _createElementVNode("h3", { class: "text-lg font-extrabold tracking-wide uppercase" }, "Loyalty Program Reward", -1))
                            ]),
                            _cache[65] || (_cache[65] = _createElementVNode("p", { class: "text-xs text-emerald-300 font-semibold mb-3" }, " * Loyalty Program will be calculated from 01-07-2026 ", -1)),
                            _createElementVNode("p", _hoisted_65, [
                              _cache[59] || (_cache[59] = _createTextVNode(" You have accumulated ")),
                              _createElementVNode("span", _hoisted_66, _toDisplayString(customerLoyaltySummary.value.points_earned), 1),
                              _cache[60] || (_cache[60] = _createTextVNode(" points (")),
                              _createElementVNode("span", _hoisted_67, "$" + _toDisplayString((Number(customerLoyaltySummary.value.points_earned) * (Number(customerLoyaltySummary.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                              _cache[61] || (_cache[61] = _createTextVNode("). Reach the target of ")),
                              _createElementVNode("span", _hoisted_68, _toDisplayString(customerLoyaltySummary.value.total_points), 1),
                              _cache[62] || (_cache[62] = _createTextVNode(" points (")),
                              _createElementVNode("span", _hoisted_69, "$" + _toDisplayString((Number(customerLoyaltySummary.value.total_points) * (Number(customerLoyaltySummary.value.redeem_rate) || 0.1)).toFixed(2)) + " USD", 1),
                              _cache[63] || (_cache[63] = _createTextVNode(") to request a withdrawal! "))
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", {
                                class: "bg-gradient-to-r from-emerald-400 to-teal-300 h-full rounded-full transition-all duration-500 shadow-[0_0_8px_rgba(52,211,153,0.5)]",
                                style: _normalizeStyle({ width: `${Math.min(100, ((Number(customerLoyaltySummary.value.points_earned) || 0) / Math.max(1, Number(customerLoyaltySummary.value.total_points) || 1)) * 100)}%` })
                              }, null, 4)
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                              _cache[64] || (_cache[64] = _createElementVNode("span", null, "0 Points", -1)),
                              _createElementVNode("span", null, _toDisplayString(Math.min(100, Math.round(((Number(customerLoyaltySummary.value.points_earned) || 0) / Math.max(1, Number(customerLoyaltySummary.value.total_points) || 1)) * 100))) + "% Completed", 1),
                              _createElementVNode("span", null, _toDisplayString(customerLoyaltySummary.value.total_points) + " Points Target", 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_72, [
                            (customerLoyaltySummary.value.pending_withdraw)
                              ? (_openBlock(), _createElementBlock("button", _hoisted_73, " Withdrawal Processing "))
                              : (Number(customerLoyaltySummary.value.points_earned) >= Number(customerLoyaltySummary.value.total_points))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: openB2CLoyaltyModal,
                                    class: "w-full md:w-auto px-6 py-3.5 bg-white text-emerald-900 hover:bg-emerald-50 active:scale-[0.98] transition-all duration-200 font-extrabold text-sm rounded-xl shadow-md uppercase tracking-wider"
                                  }, " Withdraw Now "))
                                : (_openBlock(), _createElementBlock("button", _hoisted_74, " Withdraw Now "))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_75, [
                      _cache[70] || (_cache[70] = _createElementVNode("div", { class: "px-6 py-4 bg-gray-50 border-b border-gray-100" }, [
                        _createElementVNode("h3", { class: "font-bold text-gray-900 text-sm" }, "Loyalty Points History")
                      ], -1)),
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("table", _hoisted_77, [
                          _cache[69] || (_cache[69] = _createElementVNode("thead", { class: "bg-gray-50/50" }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", {
                                scope: "col",
                                class: "py-3.5 pl-6 pr-3 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                              }, "Date"),
                              _createElementVNode("th", {
                                scope: "col",
                                class: "px-3 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                              }, "Booking ID"),
                              _createElementVNode("th", {
                                scope: "col",
                                class: "px-3 py-3.5 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                              }, "Booking Amount"),
                              _createElementVNode("th", {
                                scope: "col",
                                class: "px-3 py-3.5 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider pr-6"
                              }, "Points")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", _hoisted_78, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(loyaltyLogsList.value, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.id,
                                class: "hover:bg-gray-50/50 transition-colors duration-150"
                              }, [
                                _createElementVNode("td", _hoisted_79, [
                                  _createTextVNode(_toDisplayString(item.created_at.split('T')[0]) + " ", 1),
                                  (Number(item.points) < 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_80, "Payout"))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", _hoisted_81, _toDisplayString(item.booking_number), 1),
                                _createElementVNode("td", _hoisted_82, _toDisplayString(item.amount_usd ? `$${Number(item.amount_usd).toFixed(2)}` : '-'), 1),
                                _createElementVNode("td", {
                                  class: _normalizeClass(["whitespace-nowrap px-3 py-4 text-sm text-right pr-6 font-bold", Number(item.points) >= 0 ? 'text-emerald-600' : 'text-rose-600'])
                                }, _toDisplayString(Number(item.points) >= 0 ? `+${Number(item.points).toFixed(2)}` : Number(item.points).toFixed(2)), 3)
                              ]))
                            }), 128)),
                            (loyaltyLogsList.value.length === 0)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_83, _cache[68] || (_cache[68] = [
                                  _createElementVNode("td", {
                                    colspan: "4",
                                    class: "text-center py-10 text-sm text-gray-500 font-medium"
                                  }, " No loyalty point transactions found. ", -1)
                                ])))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (showLoyaltyRedeemModal.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                      _cache[79] || (_cache[79] = _createElementVNode("h3", { class: "text-xl font-bold text-gray-900 mb-2" }, "Request Loyalty Points Payout", -1)),
                      _cache[80] || (_cache[80] = _createElementVNode("p", { class: "text-xs text-gray-500 font-medium mb-6" }, "Enter bank details to receive the cash value.", -1)),
                      _createElementVNode("div", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, [
                          _cache[72] || (_cache[72] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Name *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((loyaltyRedeemForm.value.bankName.value) = $event)),
                            type: "text",
                            class: "w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-gray-900 text-sm outline-none focus:border-theme-active focus:bg-white"
                          }, null, 512), [
                            [_vModelText, loyaltyRedeemForm.value.bankName.value]
                          ]),
                          (loyaltyRedeemForm.value.bankName.error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_88, "Required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _cache[73] || (_cache[73] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account Title Name *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((loyaltyRedeemForm.value.accountName.value) = $event)),
                            type: "text",
                            class: "w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-gray-900 text-sm outline-none focus:border-theme-active focus:bg-white"
                          }, null, 512), [
                            [_vModelText, loyaltyRedeemForm.value.accountName.value]
                          ]),
                          (loyaltyRedeemForm.value.accountName.error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_90, "Required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_91, [
                          _cache[74] || (_cache[74] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Account Number or IBAN *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((loyaltyRedeemForm.value.accountNumber.value) = $event)),
                            type: "text",
                            class: "w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-gray-900 text-sm outline-none focus:border-theme-active focus:bg-white"
                          }, null, 512), [
                            [_vModelText, loyaltyRedeemForm.value.accountNumber.value]
                          ]),
                          (loyaltyRedeemForm.value.accountNumber.error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_92, "Required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_93, [
                          _cache[75] || (_cache[75] = _createElementVNode("label", { class: "text-xs font-semibold text-gray-400 uppercase tracking-wider" }, "Bank Country *", -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((loyaltyRedeemForm.value.countryName.value) = $event)),
                            type: "text",
                            class: "w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-gray-900 text-sm outline-none focus:border-theme-active focus:bg-white"
                          }, null, 512), [
                            [_vModelText, loyaltyRedeemForm.value.countryName.value]
                          ]),
                          (loyaltyRedeemForm.value.countryName.error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_94, "Required"))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_95, [
                          _cache[77] || (_cache[77] = _createElementVNode("label", {
                            for: "b2c-withdraw-points",
                            class: "text-xs font-semibold text-gray-400 uppercase tracking-wider text-left"
                          }, "Points to Withdraw *", -1)),
                          _createElementVNode("div", _hoisted_96, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((b2cPointsToWithdraw).value = $event)),
                              type: "number",
                              id: "b2c-withdraw-points",
                              max: customerLoyaltySummary.value?.points_earned,
                              placeholder: "Enter points count",
                              class: "w-full bg-transparent outline-none px-4 py-2.5 font-bold text-gray-800 text-sm"
                            }, null, 8, _hoisted_97), [
                              [_vModelText, b2cPointsToWithdraw.value]
                            ]),
                            _createElementVNode("span", _hoisted_98, " $" + _toDisplayString((Number(b2cPointsToWithdraw.value || 0) * (Number(customerLoyaltySummary.value?.redeem_rate) || 0.1)).toFixed(2)) + " USD ", 1)
                          ]),
                          (b2cPointsError.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(b2cPointsError.value), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("p", _hoisted_100, [
                            _cache[76] || (_cache[76] = _createTextVNode("Available balance: ")),
                            _createElementVNode("strong", null, _toDisplayString(customerLoyaltySummary.value?.points_earned), 1)
                          ])
                        ]),
                        (loyaltyRedeemForm.value.error)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(loyaltyRedeemForm.value.error), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: _cache[27] || (_cache[27] = ($event: any) => (showLoyaltyRedeemModal.value = false)),
                            class: "px-5 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-xl text-xs font-bold text-gray-600 uppercase transition-all"
                          }, "Cancel"),
                          _createElementVNode("button", {
                            type: "button",
                            onClick: handleLoyaltySubmit,
                            disabled: isLoyaltyBusy.value,
                            class: "px-5 py-2.5 bg-theme-active text-white rounded-xl text-xs font-bold uppercase hover:bg-theme-active/90 disabled:opacity-50 transition-all flex items-center gap-1.5"
                          }, [
                            (isLoyaltyBusy.value)
                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                  key: 0,
                                  icon: "fa-solid fa-spinner",
                                  class: "animate-spin"
                                }))
                              : _createCommentVNode("", true),
                            _cache[78] || (_cache[78] = _createTextVNode(" Submit "))
                          ], 8, _hoisted_103)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (showPasswordChangeAlert.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("div", _hoisted_106, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "fa-solid fa-lock",
                      class: "text-3xl"
                    })
                  ]),
                  _cache[81] || (_cache[81] = _createElementVNode("h3", { class: "text-2xl font-bold text-gray-900 tracking-tight" }, "Security Alert!", -1)),
                  _cache[82] || (_cache[82] = _createElementVNode("p", { class: "mt-3 text-sm text-gray-500 leading-relaxed font-regular" }, " You are logged in with a temporary system password. For your security, you must update your password before you can view your bookings or manage your profile. ", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[28] || (_cache[28] = ($event: any) => (showPasswordChangeAlert.value = false)),
                    class: "mt-8 w-full rounded-xl bg-theme-active hover:bg-theme-active/90 text-white font-bold text-sm py-4 shadow-lg transition-all duration-300 tracking-wide uppercase"
                  }, " Change Password Now ")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(Notification, {
      show: notif.value.show,
      type: notif.value.type,
      message: notif.value.message,
      messageDetails: notif.value.messageDetails,
      onClosed: notifClosed
    }, null, 8, ["show", "type", "message", "messageDetails"])
  ], 64))
}
}

})